module.exports = __webpack_public_path__ + "static/media/black-and-gray-dome-tent-1795507.000a0ec0.jpg";